import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { ArrowLeftIcon, Button, Typography } from '@blade/ui-kit'

import type { ClassNameProps } from '@root/shared/lib/react'

type NewWalletHeaderProps = {
  onBack: () => void
} & ClassNameProps
export const NewWalletHeader: React.FC<NewWalletHeaderProps> = ({
  className,
  onBack,
}) => {
  const { t } = useTranslation()

  return (
    <Root className={className}>
      <Button
        variant="secondary"
        size="h32"
        iconLeft={<ArrowLeftIcon />}
        onClick={onBack}
      />
      <Title variant="body1-bold">{t('wallet.create.new-wallet')}</Title>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding-block: 16px 8px;
  padding-inline: 12px;
`

const Title = styled(Typography)`
  color: var(--text-12);
  text-align: center;
`
